import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'container',
	theme => `
		
		position: relative;
		width: 100%;
		height: 40px;
		border: 1px solid ${theme.survey.option.default.border.color};
		font-size: 18px;
		border-radius: 4px;
		line-height: 1.5;
		cursor: pointer;
		box-sizing: border-box;
	`
  ],
  [
    'select',
	`
		:lang(ar) {
			direction: rtl;
		}
		width: 100%;
		height: 100%;
		cursor: pointer;
		opacity: 0;

		&::-ms-expand {
			display: none;
		}
	`
  ],
  [
    'ghost',
    `
		display: flex;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
	`
  ],
  [
    'placeholder',
	`
		:lang(ar) {
			transform: scaleX(-1);
			direction: rtl;
		}
		width: calc(100% - 3em);
		font-size: 1em;
		line-height: 1.5;
		padding-left: 10px;
		box-sizing: border-box;
	`
  ],
  [
    'icon',
    theme => `
		width: 3em;
		text-align: center;
		color: ${theme.color.primary.default};
	`
  ]
]);
